"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createVideoMediaInfo = void 0;
var chance_1 = require("../chance");
var chance = (0, chance_1.getChance)();
var createVideoMediaInfo = function () { return ({
    fileInput: {
        audioBitrate: chance.natural(),
        displayAspectRatio: '16:9',
        duration: chance.natural(),
        fileSize: chance.natural(),
        fps: '12200/407',
        height: chance.natural(),
        originalFileName: chance.file({ extention: 'm4v' }),
        rotation: 0,
        sampleAspectRatio: '1:1',
        type: 'video',
        videoBitrate: chance.natural(),
        width: chance.natural(),
    },
    fileName: chance.hash(),
    fileOutput: {
        clip: [],
        image: [],
        storyboard: [],
        video: [],
    },
    opStatus: 'READY',
}); };
exports.createVideoMediaInfo = createVideoMediaInfo;
//# sourceMappingURL=_media-info.js.map